import React, { useCallback, useEffect, useRef, useState } from 'react';
import RelatoriosOryaMarkdownView from '../relatorios/components/RelatoriosOryaMarkdownView';
import OryaThinkingStatus from '../documentation/components/OryaThinkingStatus';
import DocumentationOryaMessageActions from '../documentation/components/DocumentationOryaMessageActions';
import { getConfigOryaFirstName } from '../config-assistant/configOryaContext';
import '../documentation/DocumentationOryaPanel.css';

/**
 * Corpo do chat Orya embutido na palette — mesma formatação e ações do painel Aprender.
 */
export default function ConfigHubOryaPanel({ messages = [], sending = false, userDisplayName = '' }) {
  const endRef = useRef(null);
  const firstName = getConfigOryaFirstName(userDisplayName);
  const hasConversation = messages.length > 0;
  const [feedbackById, setFeedbackById] = useState({});

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, sending]);

  const handleMessageFeedback = useCallback((messageId, fb) => {
    setFeedbackById((prev) => ({ ...prev, [messageId]: fb }));
  }, []);

  if (!hasConversation && !sending) {
    return (
      <div className="config-hub-palette-orya-welcome">
        <h2>Olá, {firstName}!</h2>
        <p>Pergunte sobre configurações — a Orya responde com base na documentação.</p>
      </div>
    );
  }

  return (
    <div className="aprender-orya-chat config-hub-palette-orya-feed" role="log" aria-label="Conversa com a Orya">
      {messages.map((msg, idx) => {
        const questionText =
          idx > 0 && messages[idx - 1]?.role === 'user'
            ? messages[idx - 1].content
            : '';
        const exportTitle = questionText
          ? String(questionText).slice(0, 48)
          : 'orya-config-resposta';

        return (
          <div
            key={msg.id}
            className={`aprender-orya-chat-msg aprender-orya-chat-msg--${msg.role}`}
          >
            {msg.role === 'assistant' ? (
              msg.isError ? (
                <p className="aprender-orya-chat-error-inline" role="alert">
                  {msg.content}
                </p>
              ) : (
                <div className="aprender-orya-chat-answer">
                  <RelatoriosOryaMarkdownView markdown={msg.content} canExport={false} />
                  <DocumentationOryaMessageActions
                    messageId={msg.id}
                    content={msg.content}
                    questionText={questionText}
                    exportTitle={exportTitle}
                    sources={msg.sources}
                    feedback={feedbackById[msg.id] || msg.feedback}
                    onFeedback={(fb) => handleMessageFeedback(msg.id, fb)}
                  />
                </div>
              )
            ) : (
              <p className="aprender-orya-chat-user-text">{msg.content}</p>
            )}
          </div>
        );
      })}
      {sending ? <OryaThinkingStatus active={sending} /> : null}
      <div ref={endRef} />
    </div>
  );
}
